import { render } from "./PapeleraReciclaje.vue?vue&type=template&id=481e09a8"
import script from "./PapeleraReciclaje.vue?vue&type=script&lang=js"
export * from "./PapeleraReciclaje.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__